module.exports = __webpack_public_path__ + "img/default_manager_icon.63672ad2.svg";